// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"jz-z","giftOrPromoSelector":"kz-z","disabled":"lz-z","subTitle":"mz-z","selectShipAddressMessage":"nz-z","changePayment":"oz-z"};